import { resolveChannelBadge } from "./channelBadge";

export function ChannelFilters() {
	const channels =
		[
			['email', 'Email'],
			['facebook', 'Facebook'],
			['mercadolivre', 'Mercado livre'],
			['instagram', 'Instagram'],
			['telegram', 'Telegram'],
			['webchat', 'Webchat'],
			['whatsapp', 'Whatsapp'],
			[['whatsappbusiness','whatsapp_business_account','whatsappcloud'], 'Whatsapp Business'],
		]

	return channels.map(([id, name]) => ({
		id,
		name,
		icon:  Array.isArray(id) ? resolveChannelBadge(id[0]) : resolveChannelBadge(id)
	}));
}
